export interface ShiftSetShift {
  start_slot: number | string;
  end_slot: number | string;
}

export function buildShiftSetSlots(
  shifts: ShiftSetShift[] = [],
  baseSlots: number[] = [],
) {
  let nextSlots = [...baseSlots];
  for (const shift of shifts) {
    let i = Number(shift.start_slot);
    const endSlot = Number(shift.end_slot);
    if (!Number.isFinite(i) || !Number.isFinite(endSlot)) {
      continue;
    }
    while (i < endSlot) {
      nextSlots.push(i);
      i += 0.5;
    }
  }
  return nextSlots;
}

export function resolveMainShift(
  tutorProfileMainShift?: string | null,
  mainShift?: string | null,
) {
  return tutorProfileMainShift || mainShift || null;
}
